import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import completedImage from "../../assests/images/Completed.png";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import LayersIcon from "@mui/icons-material/Layers";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import purchaseImage from "../../assests/images/Purchase.png";
import pendingImage from "../../assests/images/Pending.png";
import shippedImage from "../../assests/images/Shipped.png";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Link, useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import holdImage from "../../assests/images/hold.png";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import recallmage from "../../assests/images/recall.png";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import Stack from "@mui/material/Stack";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import checkImage from "../../assests/images/check-circle.png";
import rejectImage from "../../assests/images/Reject.png";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import StepContent from "@mui/material/StepContent";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import topArrow from '../../assests/images/top.png';
import topHighlightArrow from '../../assests/images/top-highlighted.png';
import bottomArrow from '../../assests/images/bottom.png';
import bottomHighlightArrow from '../../assests/images/bottom-highlighted.png';
import CachedOutlinedIcon from '@mui/icons-material/CachedOutlined';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const initialColumns = [
  { id: "asnNumber", label: "ASN Number", isSort: true, sortLabel: "" },
  { id: "poNumber", label: "PO Number", isSort: true, sortLabel: "" },
  { id: "orderDate", label: "Order Date", isSort: true, sortLabel: "" },
  { id: "buyerName", label: "Buyer Name", isSort: true, sortLabel: "" },
  { id: "companyId", label: "Company ID", isSort: true, sortLabel: "" },
  { id: "asnQty", label: "ASN Qty", isSort: true, sortLabel: "" },
  { id: "receivedQty", label: "Received Qty", isSort: true, sortLabel: "" },
  { id: "pendingQty", label: "Pending Qty", isSort: true, sortLabel: "" },
  { id: "backorderedQty", label: "Backordered Qty", isSort: true, sortLabel: "" },
  { id: "totalAmount", label: "Total Amount", isSort: true, sortLabel: "" },
  { id: "status", label: "Status", isSort: true, sortLabel: "" },
  { id: "paymentTerms", label: "Payment Terms", isSort: true, sortLabel: "" },
  { id: "expectedDeliveryDate", label: "Expected Delivery Date", isSort: true, sortLabel: "" },
  { id: "lastUpdated", label: "Last Updated", isSort: true, sortLabel: "" },
  { id: "actions", label: "Actions" },
];

const initialData = [
  {
    id: "1",
    asnNumber: "00701",
    poNumber: "00701",
    orderDate: "12-01-2024",
    buyerName: (
      <Link to="/admin/asn-detail" style={{ textDecoration: "none" }}>
        Suntech Solutions
      </Link>
    ),
    companyId: "68GHP89",
    asnQty: 5,
    receivedQty: 2,
    pendingQty: 3,
    backorderedQty: 8,
    totalAmount: "₹ 35,600",
    status: "Pending",
    paymentTerms: "Net 30",
    expectedDeliveryDate: "14-01-2024",
    lastUpdated: "14-01-2024",
    actions: <MoreVertIcon />,
  },
  {
    id: "2",
    asnNumber: "00702",
    poNumber: "00702",
    orderDate: "14-01-2024",
    buyerName: "WindFlow Inc.",
    companyId: "68GHP89",
    asnQty: 3,
    receivedQty: 1,
    pendingQty: 2,
    backorderedQty: 7,
    totalAmount: "₹ 45,600",
    status: "Confirmed",
    paymentTerms: "Net 45",
    expectedDeliveryDate: "14-01-2024",
    lastUpdated: "14-01-2024",
    actions: <MoreVertIcon />,
  },
  {
    id: "3",
    asnNumber: "00703",
    poNumber: "00703",
    orderDate: "17-01-2024",
    buyerName: "HydroPower Tech",
    companyId: "68GHP89",
    asnQty: 1,
    receivedQty: 0,
    pendingQty: 1,
    backorderedQty: 8,
    totalAmount: "₹ 32,600",
    status: "Shipped",
    paymentTerms: "Net 30",
    expectedDeliveryDate: "19-01-2024",
    lastUpdated: "19-01-2024",
    actions: <MoreVertIcon />,
  },
  {
    id: "4",
    asnNumber: "00704",
    poNumber: "00704",
    orderDate: "22-01-2024",
    buyerName: "EcoMaterials Ltd.",
    companyId: "68GHP89",
    asnQty: 6,
    receivedQty: 3,
    pendingQty: 3,
    backorderedQty: 7,
    totalAmount: "₹ 52,600",
    status: "Completed",
    paymentTerms: "Net 45",
    expectedDeliveryDate: "24-01-2024",
    lastUpdated: "24-01-2024",
    actions: <MoreVertIcon />,
  },
  {
    id: "5",
    asnNumber: "00705",
    poNumber: "00705",
    orderDate: "17-01-2024",
    buyerName: "WindFlow Inc.",
    companyId: "68GHP89",
    asnQty: 4,
    receivedQty: 2,
    pendingQty: 2,
    backorderedQty: 9,
    totalAmount: "₹ 60,600",
    status: "Completed",
    paymentTerms: "Net 30",
    expectedDeliveryDate: "30-01-2024",
    lastUpdated: "30-01-2024",
    actions: <MoreVertIcon />,
  },
  {
    id: "6",
    asnNumber: "00706",
    poNumber: "00706",
    orderDate: "17-01-2024",
    buyerName: "EcoMaterials Ltd.",
    companyId: "68GHP89",
    asnQty: 6,
    receivedQty: 3,
    pendingQty: 3,
    backorderedQty: 7,
    totalAmount: "₹ 52,600",
    status: "Completed",
    paymentTerms: "Net 45",
    expectedDeliveryDate: "24-01-2024",
    lastUpdated: "24-01-2024",
    actions: <MoreVertIcon />,
  },
  {
    id: "7",
    asnNumber: "00706",
    poNumber: "00706",
    orderDate: "17-01-2024",
    buyerName: "EcoMaterials Ltd.",
    companyId: "68GHP89",
    asnQty: 6,
    receivedQty: 3,
    pendingQty: 3,
    backorderedQty: 7,
    totalAmount: "₹ 52,600",
    status: "Completed",
    paymentTerms: "Net 45",
    expectedDeliveryDate: "24-01-2024",
    lastUpdated: "24-01-2024",
    actions: <MoreVertIcon />,
  },
  {
    id: "8",
    asnNumber: "00706",
    poNumber: "00706",
    orderDate: "17-01-2024",
    buyerName: "EcoMaterials Ltd.",
    companyId: "68GHP89",
    asnQty: 6,
    receivedQty: 3,
    pendingQty: 3,
    backorderedQty: 7,
    totalAmount: "₹ 52,600",
    status: "Completed",
    paymentTerms: "Net 45",
    expectedDeliveryDate: "24-01-2024",
    lastUpdated: "24-01-2024",
    actions: <MoreVertIcon />,
  },
];
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "35%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const style2 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "45%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const steps = [
  {
    label: "PO Creation",
    text: "Created on : 12-02-2024",
    description: `Created At : 10:00`,
    remarks: `Created By : Sanjeev`,
  },
  {
    label: "PO Approval",
    text: "Approved on : 12-02-2024",
    description: `Approved By : Sanjeev`,
  },
  {
    label: "QC Creation : QC0001, QC0002",
    headings: "QC0001",
    text: "Approved on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `Approved By : Sanjeev`,
    headings2: "QC0002",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Creation : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0002",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "QC Creation : QC0003, QC0004",
    headings: "QC0003",
    text: "QC Created on : 12-02-2024",
    remarks: "QC Created At : 10:00",
    description: `QC Created By : Sanjeev`,
    headings2: "QC0004",
    remarks2: "QC Created on : 12-02-2024",
    description2: "QC Created At : 10:00",
    text2: "QC Created By : Sanjeev"
  },
  {
    label: "LR Delivered : LR0001, LR0002",
    headings: "LR0001",
    text: "LR Created on : 12-02-2024",
    remarks: "LR Created At : 10:00",
    description: `LR Created By : Sanjeev`,
    headings2: "LR0004",
    remarks2: "LR Created on : 12-02-2024",
    description2: "LR Created At : 10:00",
    text2: "LR Created By : Sanjeev"
  },
  {
    label: "Gate Creation : GE0001, GE0002",
    headings: "GE0001",
    text: "GE Created on : 12-02-2024",
    remarks: "GE Created At : 10:00",
    description: `GE Created By : Sanjeev`,
    headings2: "GE0002",
    remarks2: "GE Created on : 12-02-2024",
    description2: "GE Created At : 10:00",
    text2: "GE Created By : Sanjeev"
  },
  {
    label: "GRN Creation : GRN0001, GRN0002",
    headings: "GRN0001",
    text: "GRN Created on : 12-02-2024",
    remarks: "GRN Created At : 10:00",
    description: `GRN Created By : Sanjeev`,
    headings2: "GRN0002",
    remarks2: "GRN Created on : 12-02-2024",
    description2: "GRN Created At : 10:00",
    text2: "GRN Created By : Sanjeev"
  },

  // Add more steps if needed...
];
function AsnVendorList() {
  const qcListing = {
    currentPage: 1,
    totalPages: 20,
  }
  const [inputPage, setInputPage] = useState(qcListing?.currentPage || 1);

  const onPaginationChange = (e, value) => {
    // let requestPayloadInit = _.cloneDeep(requestPayload);
    // requestPayloadInit.pageNumber = value;
    // setRequestPayload(requestPayloadInit); 
  }
  const handleInputChange = (event) => {
    const value = event.target.value;
    if (value === '' || /^[0-9]+$/.test(value)) {
      setInputPage(value);
    }
  };

  const handleInputSubmit = (event) => {
    if (event.key === 'Enter') {
      const page = parseInt(inputPage, 10);
      if (!isNaN(page) && page > 0 && page <= qcListing?.totalPages) {
        onPaginationChange(event, page);
      } else {
        setInputPage(qcListing?.currentPage);
      }
    }
  };
  const [openheaderlevelexcelmodal, setOpenHeaderLevelExcelModal] =
    useState(false);
  const [openheaderlevelsucessfullymodal, setOpenHeaderLevelSucessfullyModal] =
    useState(false);
  const [openheaderlevelrejectedmodal, setOpenHeaderLevelRejectedModal] =
    useState(false);
  const [openlineitemlevelexcelmodal, setOpenLineItemLevelExcelModal] =
    useState(false);
  const [openlineitemlevelsuccessmodal, setOpenLineItemLevelSuccessModal] =
    useState(false);
  const [openlineitemlevelrejectedmodal, setOpenLineItemLevelRejectedModal] =
    useState(false);
  const [openrelaseesignmodals, setopenRelaseESignModals] = useState(false);
  const [openrelaseesignsuccessmodals, setopenRelaseESignSuccessModals] =
    useState(false);
  const [openrelaseesignrejectedmodals, setopenRelaseESignRejectedModals] =
    useState(false);
  const [openpopdfpurchasemodal, setOpenPoPdfPurchaseModal] = useState(false);
  const [openpopdfpurchasesuccessmodal, setOpenPoPdfPurchaseSuccessModal] =
    useState(false);
  const [openpopdfpurchaserejectedmodal, setOpenPoPdfPurchaseRejectedModal] =
    useState(false);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [downloadEl, setdownloadEl] = React.useState(null);
  const [openasnlisthold, setOpenAsnListHold] = useState(false);
  const [openasnlistholdsuccessfully, setOpenAsnListHoldSuccessfully] =
    useState(false);
  const [openrecallmodal, setOpenRecallModal] = useState(false);
  const [openrecallmodalsuccessfully, setOpenRecallModalSuccessfully] =
    useState(false);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const download = Boolean(downloadEl);
  const handleClicks = (event) => {
    setdownloadEl(event.currentTarget);
  };
  const handleCloses = () => {
    setdownloadEl(null);
  };

  const [columns, setColumns] = useState(initialColumns);
  const [data] = useState(initialData);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);

    setColumns(reorderedColumns);
  };

  const reducer = (state, action) => {
    switch (action.type) {
      case "TOGGLE_DRAWER":
        return { ...state, open: action.newOpen };
      default:
        throw new Error(`Unknown action: ${action.type}`);
    }
  };
  const [state, dispatch] = React.useReducer(reducer, { open: false });
  const toggleDrawer = (newOpen) => () => {
    dispatch({ type: "TOGGLE_DRAWER", newOpen });
  };
  const onSortChange = (index, sortBy, sortOrder) => {
    let newSortLael = (sortOrder == "asc") ? "desc" : "asc";
  }
  const DrawerList = (
    <Box
      sx={{
        width: 350,
        zIndex: 1300,
      }}
      role="presentation"
    >
      <List>
        <div className="row_order_sidebar_bdpt_po_div">
          <div className="track_order_form_bdpt_sm">
            <h6 className="main_heading_trackordertexr">Track Order</h6>
            <div>
              <CachedOutlinedIcon />
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={toggleDrawer(false)}
              ></button>
            </div>
          </div>
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">PO Number</h6>
              <p className="username_bpdt_div_react_row1">00234</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Status</h6>
              <p class="date_solutions_status_row">Pending</p>
            </div>
          </div>
          <div className="track_order_row_bpdt_react">
            <div>
              <h6 className="username_bpdt_div_react">Creation Date</h6>
              <p className="username_bpdt_div_react_row1">12-02-2024</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Target Date</h6>
              <p className="username_bpdt_div_react_row1">16-03-2024</p>
            </div>
            <div>
              <h6 className="username_bpdt_div_react">Delivery Date</h6>
              <p className="username_bpdt_div_react_row1">19-03-2024</p>
            </div>
          </div>
        </div>
      </List>
      <Divider />
      <List>
        <div>
          <Box className="po_detail_bfdt_row_div_sidebar1 trackorder_section">
            <Stepper orientation="vertical">
              {steps.map((step, index) => (
                <Step style={{ display: "-webkit-box" }} key={index} expanded>
                  {index === 0 || index === 1 ? (
                    <div>
                      {" "}
                      <StepLabel>{step.label}</StepLabel>
                      <StepContent>
                        {step.headings && (
                          <Typography sx={{ mt: 1 }}>
                            {step.headings}
                          </Typography>
                        )}
                        {step.text && (
                          <Typography sx={{ mt: 1 }}>{step.text}</Typography>
                        )}
                        {step.remarks && (
                          <Typography sx={{ mt: 1 }}>{step.remarks}</Typography>
                        )}
                        <Typography>{step.description}</Typography>
                      </StepContent>
                      <StepContent>
                        {step.headings2 && (
                          <Typography
                            className="stepcontent_block_body"
                            sx={{ mt: 1 }}
                          >
                            {step.headings2}
                          </Typography>
                        )}
                        {step.remarks2 && (
                          <Typography sx={{ mt: 1 }}>
                            {step.remarks2}
                          </Typography>
                        )}
                        {step.description2 && (
                          <Typography sx={{ mt: 1 }}>
                            {step.description2}
                          </Typography>
                        )}
                        {step.text2 && (
                          <Typography sx={{ mt: 1 }}>{step.text2}</Typography>
                        )}
                      </StepContent>{" "}
                    </div>
                  ) : (
                    <div>
                      <StepLabel>
                        <Accordion>
                          <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                          >
                            {step.label}
                          </AccordionSummary>

                          <AccordionDetails>
                            {step.headings && (
                              <Typography sx={{ mt: 1 }}>
                                {step.headings}
                              </Typography>
                            )}
                            {step.text && (
                              <Typography sx={{ mt: 1 }}>
                                {step.text}
                              </Typography>
                            )}
                            {step.remarks && (
                              <Typography sx={{ mt: 1 }}>
                                {step.remarks}
                              </Typography>
                            )}
                            <Typography>{step.description}</Typography>

                            {step.headings2 && (
                              <Typography
                                className="stepcontent_block_body"
                                sx={{ mt: 1 }}
                              >
                                {step.headings2}
                              </Typography>
                            )}
                            {step.remarks2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.remarks2}
                              </Typography>
                            )}
                            {step.description2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.description2}
                              </Typography>
                            )}
                            {step.text2 && (
                              <Typography sx={{ mt: 1 }}>
                                {step.text2}
                              </Typography>
                            )}
                          </AccordionDetails>
                        </Accordion>
                      </StepLabel>
                    </div>
                  )}
                </Step>
              ))}
            </Stepper>
          </Box>
        </div>
      </List>
    </Box>
  );
  return (
    <>
      <div className="login-forms">
        <div className="text-centers row_purchase_invoice_dragdropcontext_apps_body">
          <div>
            <div className="search_filter_outerse ms-auto">
              <div className="search_main">
                <h5>ASN Listing</h5>
              </div>
              <div className="bpdt_po_order_react_asn">
                <button className="create_btn_lr_creations">
                  <Link
                    style={{ color: "white", textDecoration: "none" }}
                    to="/admin/vendor-LR-Creation"
                  >
                    Create LR
                  </Link>
                </button>
                <div>
                  <Button
                    className="vendor_btn vendor_maine_contents"
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  >
                    <LayersIcon />
                    Action
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={setOpenAsnListHold}>Hold</MenuItem>
                    <MenuItem onClick={setOpenRecallModal}>Recall</MenuItem>
                    <MenuItem onClick={handleClose}>Cancel ASN</MenuItem>
                    <MenuItem onClick={handleClose}>Request for QC</MenuItem>
                  </Menu>
                </div>
                <div>
                  <button className="vendor_btn vendor_maine_contents">
                    <Link
                      className="solutions_block_body"
                      style={{ color: "white", textDecoration: "none" }}
                      to="/admin/asn-detail"
                    >
                      <AddIcon />
                      Create ASN
                    </Link>
                  </button>
                </div>
                <div>
                  <Button
                    className="vendor_btn vendor_maine_contents"
                    id="basic-button"
                    aria-controls={download ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={download ? "true" : undefined}
                    onClick={handleClicks}
                  >
                    <FileDownloadIcon />
                    Download
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={downloadEl}
                    open={download}
                    onClose={handleCloses}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem onClick={setOpenHeaderLevelExcelModal}>
                      Header Level Excel
                    </MenuItem>
                    <MenuItem onClick={setOpenLineItemLevelExcelModal}>
                      Line Item Level Excel
                    </MenuItem>
                    <MenuItem onClick={setOpenPoPdfPurchaseModal}>
                      PO PDF
                    </MenuItem>
                  </Menu>
                </div>
              </div>
            </div>
            <div className="account_ledger_listing_row1">
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total ASN
                    </label>
                    <p className="block_detail_listing">
                      <b>345</b>
                    </p>
                  </div>
           <img className="purchase_images_letscom"
                    src={purchaseImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Pending ASN
                    </label>
                    <p className="block_detail_listing">
                      <b>145</b>
                    </p>
                  </div>

           <img className="purchase_images_letscom"
                    src={pendingImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Shipped Order
                    </label>
                    <p className="block_detail_listing">
                      <b>34</b>
                    </p>
                  </div>
              <img className="purchase_images_letscom"
                    src={shippedImage}
                    alt=""
                  />
                </div>
              </div>
              <div className="accout_ledger_listing_block1">
                <div className="listing_project_block_7">
                  <div className="lets_detail_orderlisting">
                    <label className="lets_completed_orderlisting">
                      Total Completed Order
                    </label>
                    <p className="block_detail_listing">
                      <b>175</b>
                    </p>
                  </div>
              <img className="purchase_images_letscom"
                    src={completedImage}
                    alt=""
                  />
                </div>
              </div>
            </div>
            <div className="search_filter_outers ms-auto">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="bpdt_po_order_react">
                <div>
                  <button className="btn btn-outline-secondary" onClick={toggleDrawer(true)}>Track Order</button>
                  <Drawer
                    anchor="right"
                    open={state.open}
                    onClose={toggleDrawer(false)}
                    style={{ zIndex: 99999 }}
                  >
                    {DrawerList}
                  </Drawer>
                </div>
                <div>
                  <button className="row_filterrbtnvendor_box">
                    <span>
                      <FilterAltOutlinedIcon />
                    </span>
                    Filter
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div style={{ width: "100%", overflow: "hidden" }}
            className="listing_main listing_main_dragdropcontext_body">
            <DragDropContext onDragEnd={onDragEnd}>
              <table className="dragdropcontext_ondragend_block_row">
                <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                  <Droppable droppableId="droppable" direction="horizontal">
                    {(provided) => (
                      <tr {...provided.droppableProps} ref={provided.innerRef}>
                        <th className="vendor_tabels">
                          <input type="checkbox" />
                        </th>
                        {columns.map((column, index) => (
                          <Draggable
                            key={column.id}
                            draggableId={column.id}
                            index={index}
                          >
                            {(provided) => (
                              <th
                                className="vendor_tabels"
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                {column.label}
                                {(column.isSort == true) && <span onClick={(e) => onSortChange(index, column.id, column.sortLabel)} className="table-sort-ico">
                                  {/* <SwapVertIcon className="swap-sort-ico" /> */}
                                  {(column.sortLabel != "asc") && <img src={topArrow} />}
                                  {(column.sortLabel == "asc") && <img src={topHighlightArrow} />}
                                  {(column.sortLabel != "desc") && <img src={bottomArrow} />}
                                  {(column.sortLabel == "desc") && <img src={bottomHighlightArrow} />}
                                </span>}
                              </th>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </tr>
                    )}
                  </Droppable>
                </thead>
                <tbody style={{ overflowY: "scroll", width: "200px" }}>
                  {data.map((row) => (
                    <tr key={row.id} className="maine_tr_vendor">
                      <td>
                        <input type="checkbox" />
                      </td>
                      {columns.map((column, index) => (
                        <td
                          key={column.id}
                          className={
                            index === 0 || index === 1 ? "block_solar" : ""
                          }
                        >
                          {row[column.id]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </DragDropContext>
          </div>
          <div className="lets_pagination_package_listing_react">
            <div className="pagination_select_react_packagelr_detail">
              <select className="form-select packagelrlisting from-hs">
                <option selected="1">10</option>
                <option value="2">15</option>
                <option value="3">20</option>
                <option value="4">25</option>
                <option value="5">50</option>
              </select>
              <span className="react_text_showing">
                &nbsp;Showing rows 1 to&nbsp;10 of&nbsp;10
              </span>
            </div>
            <Stack spacing={2}>
              <Pagination
                count={qcListing?.totalPages}
                page={qcListing?.currentPage}
                onChange={(event, page) => {
                  setInputPage(page);
                  onPaginationChange(event, page);
                }}
                renderItem={(item) => {
                  if (item.page === qcListing?.currentPage) {
                    return (
                      <input
                        className="form-control"
                        type="text"
                        value={inputPage}
                        onChange={handleInputChange}
                        onKeyDown={handleInputSubmit}
                        style={{ width: "50px", marginLeft: "5px", marginRight: "5px", textAlign: "center" }}
                      />
                    );
                  }
                  return (
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  );
                }}
              // count={5}
              // renderItem={(item) => (
              //   <PaginationItem
              //     className="pagination_react_listings"
              //     slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
              //     {...item}
              //   />
              // )}
              />
            </Stack>
          </div>
          {/* ASN Hold Modal Vendor ASN */}
          <Modal
            open={openasnlisthold}
            onClose={() => setOpenAsnListHold(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnListHold(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Hold</b>" selected ASN?
                  <br />
                  ASN No. :<b>00701</b> | ASN Amount : <b>₹35,600</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenAsnListHold(false);
                      setOpenAsnListHoldSuccessfully(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenAsnListHold(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/*  ASN Hold sucessfully Modal  */}
          <Modal
            open={openasnlistholdsuccessfully}
            onClose={() => setOpenAsnListHoldSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenAsnListHoldSuccessfully(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={holdImage} alt="" />
                    <p className="profile_react_block">
                      Selected ASN has been "<b>Hold</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      ASN No. : <b>07001 |</b> ASN Amount :<b> ₹35,600 |</b> ASN
                      Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenAsnListHoldSuccessfully(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal>
          {/* ASN Recall Modal Vendor ASN */}
          <Modal
            open={openrecallmodal}
            onClose={() => setOpenRecallModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRecallModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to "<b>Recall</b>" selected ASN?
                  <br /> ASN No. : <b>00701 |</b> ASN Amount : <b>₹35,600</b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenRecallModal(false);
                      setOpenRecallModalSuccessfully(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => setOpenRecallModal(false)}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/*  ASN Recall sucessfully Modal  */}
          <Modal
            open={openrecallmodalsuccessfully}
            onClose={() => setOpenRecallModalSuccessfully(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRecallModalSuccessfully(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="approvel_btn_successfully">
                    <img src={recallmage} alt="" />
                    <p className="profile_react_block">
                      Selected ASN has been "<b>Hold</b>" Successfully
                    </p>
                    <p className="profile_react_blocks">
                      ASN No. : <b>07001 |</b> ASN Amount :<b> ₹35,600 |</b> ASN
                      Qty : <b>12</b>
                    </p>
                    <button
                      className="view_progresse"
                      onClick={() => setOpenRecallModalSuccessfully(false)}
                    >
                      Ok
                    </button>
                  </div>
                </form>
              </div>
            </Box>
          </Modal>
          {/* Header Level Excel Purchase listing */}
          <Modal
            open={openheaderlevelexcelmodal}
            onClose={() => setOpenHeaderLevelExcelModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHeaderLevelExcelModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to download
                  <br /> Header Level Excel
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenHeaderLevelExcelModal(false);
                      setOpenHeaderLevelSucessfullyModal(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setOpenHeaderLevelExcelModal(false);
                      setOpenHeaderLevelRejectedModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Header Level Sucessfully Purchase listing */}
          <Modal
            open={openheaderlevelsucessfullymodal}
            onClose={() => setOpenHeaderLevelSucessfullyModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHeaderLevelSucessfullyModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>Header Level</b> has been
                  <br /> successful download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenHeaderLevelSucessfullyModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Header Level Rejected Purchase listing */}
          <Modal
            open={openheaderlevelrejectedmodal}
            onClose={() => setOpenHeaderLevelRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenHeaderLevelRejectedModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>Header Level</b> has been
                  <br /> Rejected download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenHeaderLevelRejectedModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Line Item Level Excel Purchase order */}
          <Modal
            open={openlineitemlevelexcelmodal}
            onClose={() => setOpenLineItemLevelExcelModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenLineItemLevelExcelModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to download
                  <br /> Line Item Level Excel
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenLineItemLevelExcelModal(false);
                      setOpenLineItemLevelSuccessModal(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setOpenLineItemLevelExcelModal(false);
                      setOpenLineItemLevelRejectedModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Line Item Level Excel Sucessfully  */}
          <Modal
            open={openlineitemlevelsuccessmodal}
            onClose={() => setOpenLineItemLevelSuccessModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenLineItemLevelSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>Line Item </b> has been
                  <br /> successful download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenLineItemLevelSuccessModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Line Item Level Excel Rejected Purchase listing */}
          <Modal
            open={openlineitemlevelrejectedmodal}
            onClose={() => setOpenLineItemLevelRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenLineItemLevelRejectedModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_manager_bidding">
                  Selected <b>Line Item</b> has been
                  <br /> Rejected download
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenLineItemLevelRejectedModal(false);
                    }}
                  >
                    Ok
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* PO PDF Modal Buyer Po */}
          <Modal
            open={openpopdfpurchasemodal}
            onClose={() => setOpenPoPdfPurchaseModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <p class="project_manager_bidding">
                  Are you sure you want to download PO Pdf
                  <br />
                  <b>PO No. : 00701 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseSuccessModal(true);
                    }}
                  >
                    Yes
                  </button>

                  <button
                    href="onboarding_status.html"
                    className="view_lsting"
                    onClick={() => {
                      setOpenPoPdfPurchaseModal(false);
                      setOpenPoPdfPurchaseRejectedModal(true);
                    }}
                  >
                    No
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* PO PDF Successfully Modal Buyer Po */}
          <Modal
            open={openpopdfpurchaserejectedmodal}
            onClose={() => setOpenPoPdfPurchaseRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseSuccessModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkImage} alt="" />
                <p class="project_manager_bidding">
                  Selected PO has been "<b>PDF Download</b>" Successfully
                  <br />
                  <b>PO No. : 07001 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseSuccessModal(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* PO PDF Rejected Modal Buyer Po */}
          <Modal
            open={openpopdfpurchaserejectedmodal}
            onClose={() => setOpenPoPdfPurchaseRejectedModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenPoPdfPurchaseRejectedModal(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={rejectImage} alt="" />
                <p class="project_manager_bidding">
                  Selected PO has been "<b>PDF Download</b>" failed
                  <br />
                  <b>PO No. : 07001 </b>
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    href="onboarding_status.html"
                    className="view_progresse"
                    onClick={() => {
                      setOpenPoPdfPurchaseRejectedModal(false);
                    }}
                  >
                    OK
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
        </div>
      </div>
    </>
  );
}

export default AsnVendorList;
